import React, { useState } from "react";
import { Form, Input } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import { renderMessage } from "../../helpers/renderInputMessage";
import { useAuth } from "../../contexts/auth";

function PersonalForm({ data }) {
  const { UpdatePartner } = useAuth();
  const [updating, setUpdating] = useState({
    country: null,
    city: null,
    postal_code: null,
    full_address: null,
  });

  const handleBlur = async (e) => {
    let payload = {};
    let temp = updating;
    const field = e.target.id;
    if (updating[field] === true) {
      temp[field] = "validating";
      setUpdating({ ...updating, ...temp });
      payload[field] = e.target.value;

      await UpdatePartner(payload)
        .then(() => {
          temp[field] = "success";
          setUpdating({ ...updating, ...temp });
        })
        .catch(() => {
          temp[field] = "error";
          setUpdating({ ...updating, ...temp });
        });
    }
  };

  return (
    <Form className="account-forms" layout="vertical">
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.billing.country" />}
        hasFeedback
        validateStatus={updating.country}
        help={renderMessage("country", updating)}
      >
        <Input
          id="country"
          size="large"
          defaultValue={data.country}
          onBlur={(e) => handleBlur(e)}
          onChange={(e) => {
            setUpdating({ ...updating, country: true });
          }}
        />
      </Form.Item>

      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.billing.city" />}
        hasFeedback
        validateStatus={updating.city}
        help={renderMessage("city", updating)}
      >
        <Input
          id="city"
          defaultValue={data.city}
          size="large"
          onBlur={(e) => handleBlur(e)}
          onChange={(e) => {
            setUpdating({ ...updating, city: true });
          }}
        />
      </Form.Item>
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.billing.postalcode" />}
        hasFeedback
        validateStatus={updating.postal_code}
        help={renderMessage("postal_code", updating)}
      >
        <Input
          id="postal_code"
          size="large"
          defaultValue={data.postal_code}
          onBlur={(e) => handleBlur(e)}
          onChange={(e) => {
            setUpdating({ ...updating, postal_code: true });
          }}
          placeholder="Zip code"
        />
      </Form.Item>
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.billing.fulladdress" />}
        hasFeedback
        validateStatus={updating.full_address}
        help={renderMessage("full_address", updating)}
      >
        <Input
          id="full_address"
          size="large"
          defaultValue={data.full_address}
          onBlur={(e) => handleBlur(e)}
          onChange={(e) => {
            setUpdating({ ...updating, full_address: true });
          }}
          placeholder="Full address"
        />
      </Form.Item>
    </Form>
  );
}
export default PersonalForm;
